import React from "react";

import "../styles.scss";
import "../scripts";

import {
  secondaryBlock,
  SecondaryBlockSize,
  KameleonElement,
  SecondaryBlockConfig,
  getDefaultProps,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";
import { Variants } from "@kameleon-util/global-theme";
import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { PointsType, layoutOptions } from "./types/prop-types";

/** Points Secondary */
const blockConfig: SecondaryBlockConfig = {
  blockSize: SecondaryBlockSize.Medium,
};

export const Points = secondaryBlock<PointsType>(
  blockConfig,
  ({
    points,
    primaryButtonText,
    primaryButtonLink,
    secondaryButtonText,
    secondaryButtonLink,
    tertiaryButtonText,
    tertiaryButtonLink,
    layoutProps,
  }: PointsType) => {
    const iconIsLeft = layoutProps.iconPosition === "left";
    const hasIconBg = layoutProps.showIconBackground;
    return (
      <Box className="secondary-points-medium-v1 margin-section-medium direction-vertical">
        <Box className="w-layout-grid layout10_item-list">
          {points?.map((point, index) => (
            <Box
              className={`layout10_item ${iconIsLeft && "flex"}`}
              key={index}
            >
              {point.icon && (
                <Box
                  className={`margin-bottom ${
                    hasIconBg && !iconIsLeft && "margin-xsmall"
                  } icon-margin-right`}
                >
                  <Variants.IconMedium
                    sx={{
                      width: hasIconBg ? "4rem" : "2rem",
                      height: iconIsLeft && !hasIconBg ? "none" : "4rem",
                    }}
                    hasBg={hasIconBg}
                    icon={point.icon}
                  />
                </Box>
              )}
              <Box>
                {point.title && (
                  <Box className="margin-bottom margin-xxsmall">
                    <Variants.Heading as="h6">{point.title}</Variants.Heading>
                  </Box>
                )}
                {point.description && (
                  <Variants.ParagraphDefault>
                    {point.description}
                  </Variants.ParagraphDefault>
                )}
              </Box>
            </Box>
          ))}
        </Box>
        <Box className="margin-top margin-custom1 gap-15">
          <Variants.ButtonGroup
            primaryButtonText={primaryButtonText}
            primaryButtonLink={primaryButtonLink}
            secondaryButtonText={secondaryButtonText}
            secondaryButtonLink={secondaryButtonLink}
            tertiaryButtonText={tertiaryButtonText}
            tertiaryButtonLink={tertiaryButtonLink}
          />
        </Box>
      </Box>
    );
  }
);

Points.defaultProps = getDefaultProps<PointsType>(defaults);

export const Element: KameleonElement = {
  component: Points,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
